module.exports = __webpack_public_path__ + "img/logo.773b05f9.jpg";